import { useMemo } from 'react';
import { useUserAgent } from '../core/util/device';
import { getDefaultBreakpoint } from '../core/util/device/screen';

export default () => {
  const userAgent = useUserAgent();
  return useMemo(() => getDefaultBreakpoint(userAgent), [userAgent]);
};
